export interface AcademyQuickStartNavItem {
  id: string
  title: string
  path: string
  order: number
}

/** Shared fallback sections for Academy Quick Start mobile navigation. */
export const ACADEMY_QUICKSTART_NAV_ITEMS: AcademyQuickStartNavItem[] = [
  { id: 'quick-start-guide', title: 'Quick Start Guide', path: 'quick-start-guide', order: 1 },
  {
    id: 'getting-started-with-swiftui-stacks',
    title: 'Getting Started with SwiftUI Stacks',
    path: 'getting-started-with-swiftui-stacks',
    order: 2,
  },
  {
    id: 'advanced-stack-techniques',
    title: 'Advanced Stack Techniques',
    path: 'advanced-stack-techniques',
    order: 3,
  },
  { id: 'stack-best-practices', title: 'Stack Best Practices', path: 'stack-best-practices', order: 4 },
]
